import React, {useState, useEffect} from 'react'
import Header from '../../components/header/Header'
import ScheduleWrapper from './ScheduleWrapper'
import ExchangeRate from './exchangeRate'
import Orders from './orders/Orders'
import BuyOrder from './orders/BuyOrder'
import Market from './market/Market'
import useIsMobile from './useIsMobile'
import {ReactComponent as BuyApprovedIco} from '../../assets/icons/main/buy-message-approved.svg'
import {ReactComponent as BuyErrorIco} from '../../assets/icons/main/buy-message-error.svg'
import './Main.css'
import axios from "axios";
import {useTranslation} from "react-i18next";

const Main = () => {
    const {t} = useTranslation()
    // На мобильном BuyOrder — шторка снизу (как в старой мобильной версии), на десктопе — встроенная колонка.
    const isMobile = useIsMobile()
    const [buyOrderstate, setBuyOrderState] = useState(false)
    const [marketState, setMarketState] = useState(false)
    const [message, setMessage] = useState({msg: t("main.successfullyPlaced"), status: "error"}) //status "error"/"approved"

    const url = new URL(document.location.href);
    let symbolMarket = (url.searchParams.get('symbol')) || "BTCUSDT";
    let match = symbolMarket.match(/(\w+)(USDT|BTC|BNB)/);

    const token = localStorage.getItem("token");
    const [userBalance, setUserBalance] = useState(0);
    const [userBalanceStatus, setUserBalanceStatus] = useState(false);
    const requireUserBalance = () => {
        if (!token) return;
        axios.get(
            `https://api-ru.fynex.cc/api/api/users/balance/futures`,
            {
                headers: {"Authorization" : `Bearer ${token}`}
            })
            .then(res => {
                setUserBalance(res.data[`${match[2].toLowerCase()}`]);
                setUserBalanceStatus(true);
            })
            .catch(() => {});
    };

    const [AVGdata, setAVGdata] = useState([]);

    useEffect(() => {
        let isMounted = true;
        axios.get(`https://api-ru.fynex.cc/charts/api/24hr/${symbolMarket}`)
            .then(res => {
                if (isMounted) setAVGdata(res.data);
            })
            .catch(() => {});
        return () => { isMounted = false; };
    }, [symbolMarket]);

    useEffect(() => {
        if (!token) return;
        requireUserBalance();
        const balanceInterval = setInterval(requireUserBalance, 3000);
        return () => clearInterval(balanceInterval);
    }, [token, symbolMarket]);
    const [ordersKey, setOrdersKey] = useState(0);

    const reloadUserData = () => {
        setOrdersKey(prevKey => prevKey + 1);
    }
    const [orderType, setOrderType] = useState(1)

    const buyOrderNode = (
        <BuyOrder orderType={orderType} setOrderType={setOrderType} balance={userBalance} balanceStatus={userBalanceStatus} reloadUserData={reloadUserData} coinFrom={match[2]} coinTo={match[1]} AVGdata={AVGdata} stateActive={isMobile ? buyOrderstate : true} setStateActive={setBuyOrderState}/>
    )
    return (
        <div className='main'>

            {/* Мобильная версия: BuyOrder открывается шторкой снизу */}
            {isMobile && (
                <div
                    className={"opening-wrapper" + (buyOrderstate ? " drawer-open" : "")}
                    onClick={(e) => { if (e.target === e.currentTarget) setBuyOrderState(false); }}
                >
                    {buyOrderNode}
                </div>
            )}

            <div
                className={"opening-market" + (marketState ? " drawer-open" : "")}
                onClick={(e) => { if (e.target === e.currentTarget) setMarketState(false); }}
            >
                <Market stateActive={marketState} setStateActive={setMarketState} />
            </div>

            <div className="main-wrapper">
                <Header deposit={true} hasMenu={true} isFixed={isMobile}/>
                <ExchangeRate setMarketState={() => setMarketState(true)} symbolMarket={symbolMarket} coinTo={match[1]} />
                <ScheduleWrapper symbolMarket={symbolMarket} coinFrom={match[2]} coinTo={match[1]}
                    buyOrderComponent={isMobile ? null : buyOrderNode}
                />

                <Orders setOrderType={setOrderType} ordersKey={ordersKey} setStateBuyOrder={setBuyOrderState} />
            </div>
        </div>
    )
}
export default Main
